module.exports = __webpack_public_path__ + "static/media/no-image.c3122a41.jpg";